<template>
    <div v-if="request && hasAccess" class="clearfix py-2">
        <top-nav-bar goto="/annual-leave">
            <button @click="editRequest" v-if="request.can_change"
                    class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-pencil mr-2"></i>
                Edit
            </button>
        </top-nav-bar>

        <h3 class="text-center" v-text="request.name"></h3>

        <div class="mb-6" v-for="(bid, index) in request.bid">
            <list>
                <list-item>
                    <template slot="icon">
                        <icon icon="fas fa-tag" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Option</template>
                    <template slot="sub-title">{{bid.option}}</template>
                </list-item>
                <list-item v-if="(index + 1) !== request.bid.length">
                    <template slot="icon">
                        <icon icon="fas fa-exclamation-circle" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Condition</template>
                    <template slot="sub-title">{{bid.condition.toUpperCase()}}</template>
                </list-item>
            </list>
        </div>

        <div class="flex md:justify-end -mx-2" v-if="request.can_change">
            <div class="flex-1 md:flex-none px-2">
                <button class="btn btn--colored__red w-full" @click="deleteRequest">
                    <i class="fal fa-trash"></i>
                    Delete
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                request: null
            }
        },

        mounted() {
            this.$api('hr').get(`annual-leave/${this.$route.params.annual_leave}/${this.$route.params.request}`)
                .then(({data}) => {
                    this.request = data.data.request;
                })
        },

        methods: {
            editRequest() {
                this.$router.push(`/annual-leave/${this.$route.params.annual_leave}/${this.$route.params.request}/edit`);
            },
            deleteRequest() {
                this.$api('hr').delete(`annual-leave/${this.$route.params.annual_leave}/${this.$route.params.request}`)
                    .then(() => {
                        this.$router.push(`/annual-leave`);
                    })
            }
        }
    }
</script>
